import getNormalizedThreadId from '@/redux/selectors/pieveSelectors/lib/getNormalizedThreadId.js';

const getThreadContentValue = ({ threadContentMapValue, threadId }) => {
  const normalizedThreadId = getNormalizedThreadId(threadId);

  if (!normalizedThreadId) {
    return null;
  }

  return threadContentMapValue?.[normalizedThreadId] || null;
};

export default getThreadContentValue;
